import { pluginActions } from 'actions/plugins-actions';
import { ComponentBuilder } from 'components/plugins-entrypoint';
import { DimensionType } from 'cvat-core-wrapper';
import { ComponentType } from 'react';
import { DeduplicationTask } from './deduplication-task';
import { DeduplicationView } from './deduplication-view';

interface DeduplicationPlugin {
    name: string;
    description: string;
    cvat: {};
    data: {
        core: any;
    };
    components: {
        view: ComponentType;
    };
}

const deduplicationPlugin: DeduplicationPlugin = {
    name: 'Deduplication',
    description: 'Handles deduplication QA tasks',
    cvat: {},
    components: {
        view: DeduplicationView,
    },
    data: {
        core: null,
    },
};

export const builder: ComponentBuilder = ({ core, dispatch }) => {
    deduplicationPlugin.data.core = core;

    dispatch(
        pluginActions.addUIComponent('annotationPage.canvas.panels', deduplicationPlugin.components.view, {
            shouldBeRendered: (p, _) => {
                const props = p as { type: DimensionType; job: unknown } | undefined;
                if (props?.type === DimensionType.DIMENSION_3D || !props?.job) {
                    console.debug('Not rendering deduplication', props);
                    return false;
                }

                const parsed = DeduplicationTask.safeParse(props.job);
                if (!parsed.success)
                    console.debug('Not a deduplication task', { job: props.job, issues: parsed.error.issues });
                return parsed.success;
            },
        }),
    );

    return {
        name: deduplicationPlugin.name,
        destructor: () => {},
    };
};

